import {
  AnalyticsInstagramDashboardPosts,
  AnalyticsInstagramDashboardOverview,
  AnalyticsInstagramDashboardAudience
} from '@anytag/shared-organisms';
import { useAnalyticsProfileContext } from '../../analytics-profile-context';

export const AnalyticsInstagramDashboard = () => {
  const { brandAccount, selectedSocialAccount } = useAnalyticsProfileContext();

  return (
    <>
      <AnalyticsInstagramDashboardOverview analyticsAccount={selectedSocialAccount} />
      <AnalyticsInstagramDashboardAudience analyticsAccount={selectedSocialAccount} />
      <AnalyticsInstagramDashboardPosts brandAccount={brandAccount} analyticsAccount={selectedSocialAccount} />
    </>
  );
};
